// Shared utility for Stripe Payment Element options
// Consolidates getElementOptions() logic from PaymentModalController

export function getStripeElementOptions(paymentMethodType) {
  const baseOptions = {
    appearance: {
      theme: 'stripe',
      variables: {
        colorPrimary: '#2675F8',
        colorBackground: '#ffffff',
        colorText: '#30313d',
        colorDanger: '#df1b41',
        fontFamily: 'system-ui, sans-serif',
        spacingUnit: '4px',
        borderRadius: '8px'
      }
    }
  };

  switch (paymentMethodType) {
    case 'card':
      return {
        ...baseOptions,
        paymentMethodTypes: ['card', 'link'],
        wallets: {
          applePay: 'never',
          googlePay: 'never'
        },
        fields: {
          billingDetails: 'auto'
        }
      };
    // feature/hli-manage-donations: card + bank account together in one tabbed Payment Element,
    // wallets/Link shown via a separate Express Checkout Element instead (mirrors the donation
    // flow's Review step -- see one_time_payment_controller.js#setupPaymentElement).
    case 'full':
      return {
        ...baseOptions,
        paymentMethodTypes: ['card', 'link', 'us_bank_account'],
        wallets: {
          applePay: 'never',
          googlePay: 'never',
          link: 'never'
        },
        fields: {
          billingDetails: 'auto'
        },
        layout: {
          type: 'tabs'
        }
      };
    case 'digital_wallets':
      return {
        ...baseOptions,
        // For digital wallets, prioritize Apple Pay and Google Pay buttons
        paymentMethodTypes: ['card', 'link'],
        wallets: {
          applePay: 'auto',
          googlePay: 'auto'
        },
        fields: {
          billingDetails: 'auto'
        },
        layout: {
          type: 'tabs',
          defaultCollapsed: false
        }
      };
    case 'acss_debit':
      return {
        ...baseOptions,
        paymentMethodTypes: ['acss_debit'],
        fields: {
          billingDetails: 'auto'
        }
      };
    case 'bacs_debit':
      return {
        ...baseOptions,
        paymentMethodTypes: ['bacs_debit'],
        fields: {
          billingDetails: 'auto'
        }
      };
    case 'us_bank_account':
      return {
        ...baseOptions,
        paymentMethodTypes: ['us_bank_account'],
        fields: {
          billingDetails: 'auto'
        }
      };
    default:
      return baseOptions;
  }
}

// Helper function to extract elements options (removes payment method specific options)
export function getElementsOptions(elementOptions) {
  const { paymentMethodTypes, fields, wallets, layout, ...elementsOptions } = elementOptions;
  return elementsOptions;
}

// Helper function to extract payment element options (keeps only payment method specific options)
export function getPaymentElementOptions(elementOptions) {
  const paymentElementOptions = {};
  if (elementOptions.fields) {
    paymentElementOptions.fields = elementOptions.fields;
  }
  if (elementOptions.wallets) {
    paymentElementOptions.wallets = elementOptions.wallets;
  }
  if (elementOptions.layout) {
    paymentElementOptions.layout = elementOptions.layout;
  }
  return paymentElementOptions;
}